<template>
  <div :class="['card-container',isMobile ? '':'pc-card']">
    <div class="ac-top">{{ content.tit }}</div>
    <div class="ac-bottom" ref="list" @scroll="onScroll" v-if="shownContentList && shownContentList.length">
      <div class="left-btn icon-arrow-right" @click="leftArrowClick" v-show="showLeftArrow"></div>
      <div class="cardList-body" @click="chooseItem(item)" v-for="item in shownContentList">
        <div class="top" v-if="item.logo">
          <img :src="item.logo" alt="" class="logo" />
        </div>
        <div class="bottom">
          <div class="bottom-top">{{ item.tit }}</div>
          <div class="bottom-bottom">
            <div class="m3" v-if="isNumSet(item.mon)">{{ item.currencyUnit }}<span>{{ item.mon }}</span></div>
            <div class="m4" v-if="isNumSet(item.much)"><span>{{ item.much }}</span>件已售</div>
          </div>
        </div>
      </div>
      <div class="right-btn icon-arrow-right" @click="rightArrowClick" v-if="showRightArrow"></div>
    </div>
  </div>
</template>

<script>

import { debounce } from '@tencent/qd-lib';
// PC按钮点击翻页，单页目前最多展示四条
const maxShownNum = 4;
export default {
  props: {
    message: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    isMobile() {
      return !this.$platform.pc;
    },
    /**
     * 实际展示的数据列表
     * 因为PC端不是滑动翻页，点击按钮翻页，这里做一个翻页交互逻辑，从数据总列表当中截取四条展示在可见区域
     */
    shownContentList() {
      if (this.isMobile) {
        return this.contentList;
      }
      return this.contentList.slice(this.leftIndex, this.rightIndex + 1);
    },
    showLeftArrow() {
      return !this.isMobile && this.leftIndex !== 0;
    },
    showRightArrow() {
      return !this.isMobile && (this.hasNext || this.rightIndex < this.contentList.length - 1);
    },
  },
  data() {
    return {
      openPop: true,
      content: {},  // 消息内容
      contentList: [], // 列表
      leftIndex: 0, // PC端展示的列表第一个元素对应数据总列表中的下标
      rightIndex: maxShownNum - 1, // PC端展示的列表最后一个元素对应数据总列表中的下标
      hasNext: true,
    };
  },
  mounted() {
    this.setContainerHeight();
    this.parseMessage(this.message);
  },
  watch: {
    message: {
      deep: true,
      handler(val) {
        this.parseMessage(val);
      },
    },
  },
  methods: {
    // 设置消息区域占位
    setContainerHeight() {
      const parent = document.querySelector(`[seq="${this.message.seq}"]`);
      if (parent) {
        parent.classList && parent.classList.add('robot-card-container');
      }
    },
    chooseItem(item) {
      this.$emit('chooseItem', item);
    },
    loadMore() {
      if (!this.hasNext) {
        return;
      }
      this.$emit('loadMore');
    },
    onScroll: debounce(function () {
      if (!this.isMobile) {
        return;
      }
      const listEl = this.$refs.list;
      if (listEl) {
        const nScrollWidth = listEl.scrollWidth;
        const nScrollLeft = listEl.scrollLeft;
        const width = listEl.offsetWidth;
        if (nScrollWidth - (nScrollLeft + width) < 10) {
          this.loadMore();
        }
      }
    }, 300),

    parseMessage(message) {
      const { content: { content: { contentData: { contentList = [], hasNext } } } } = message; // 消息解构一下，避免渲染的时候字段层级太深
      this.content = this.message?.content?.content;
      this.contentList = contentList;
      this.hasNext = hasNext;
      if (this.shownContentList.length < maxShownNum && this.rightIndex < this.contentList.length - 1) {
        this.rightIndex = this.rightIndex + (maxShownNum - this.shownContentList.length) >  this.contentList.length - 1
          ? this.contentList.length - 1 : this.rightIndex + (maxShownNum - this.shownContentList.length);
      }
    },
    // 右翻页按钮点击
    rightArrowClick() {
      this.leftIndex = this.rightIndex + 1;
      this.rightIndex = this.rightIndex + maxShownNum > this.contentList.length - 1
        ? this.contentList.length  - 1 : this.rightIndex + maxShownNum;
      if (this.shownContentList.length < maxShownNum && this.hasNext) {
        this.loadMore();
      }
    },
    // 左侧翻页按钮点击
    leftArrowClick() {
      this.rightIndex = this.leftIndex - 1;
      this.leftIndex = this.leftIndex - maxShownNum;
    },
    isNumSet(num) {
      return  num || String(num) === '0';
    },
  },
};
</script>

<style lang="less" scoped>
.card-container {
  position: relative;
}

// 横划卡片列表
.ac-bottom {
  position: absolute;
  top: 30px;
  padding: 30px 0 0 20px;
  overflow-y: hidden;
  overflow-x: scroll;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  // width: 100%;
  box-sizing: border-box;
  height: 240px;
  width: 100vw;
  left: -74px;

  // width: 3934px;
  .cardList-body {
    width: 153.3px;
    margin-left: 12px;
    background: #ffffff;
    box-shadow: 0px 1px 10px rgba(225, 230, 240, 0.5);
    border-radius: 6px;

    &:first-child {
      margin-left: 0;
    }

    .top {
      width: 100%;
      height: 152px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .bottom {
      padding: 8px 12px 12px;

      .bottom-top {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-family: PingFang SC;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        color: #000000;
      }

      .bottom-bottom {
        display: flex;
        justify-content: space-between;
        padding-top: 8px;
        font-style: normal;
        font-size: 12px;

        .m3 {
          font-family: Helvetica Neue;
          font-weight: bold;
          line-height: 16px;
          color: #ff8147;
        }

        .m4 {
          font-family: PingFang SC;
          font-weight: normal;
          line-height: 17px;
          color: #a1abc2;
        }
      }
    }
  }

  /*去除滚动条*/
  &::-webkit-scrollbar {
    display: none;
  }

  .right-btn {
    position: absolute;
    top: 50%;
    right: 6px;
    transform: translateY(-50%) rotate(0deg);
    width: 32px;
    height: 32px;
    background: #161616;
    mix-blend-mode: normal;
    opacity: .2;
    border-radius: 16px;
    font-size: 16px;
    line-height: 32px;
    text-align: center;
    color: #fff;
    cursor: pointer;
  }

  .icon-arrow-right:before {
    content: "\e912";
  }

  .left-btn {
    position: absolute;
    left: 63px;
    transform: translate(-75%, -50%) rotate(180deg);
    top: 50%;
    width: 32px;
    height: 32px;
    background: #161616;
    mix-blend-mode: normal;
    opacity: .2;
    border-radius: 16px;
    font-size: 16px;
    line-height: 32px;
    text-align: center;
    color: #fff;
    cursor: pointer;

  }
}
.pc-card {
  .ac-bottom{
    max-width: 680px;
  }
  .cardList-body{
    flex-shrink: 0;
  }
}
</style>
